export default __webpack_public_path__ + "static/media/Q6_0_resized.f0dc54ea.jpg";